/* eslint-disable react/prop-types */
/* eslint-disable max-len */
import './styles.css';
import alert from '../../Assets/AlertIcon/alertIcon.svg';
export default function HeadingFttsLandingPageButton(props) {
  const { handleDrawerClose } = props;
  return (
    <div className="alerts_header">
      <div className="alerts_title_icon">
        <img alt="" src={alert} />
        <h3> Alarms Notification </h3>
      </div>
      <button className="crossButton" onClick={handleDrawerClose}>
        <svg
          width="10"
          height="10"
          style={{ paddingTop: '5px' }}
          viewBox="0 0 12 12"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M7.77778 5.9979L11.6352 2.14181C12.1216 1.6556 12.1216 0.850855 11.6352 0.364652C11.1489 -0.121551 10.3438 -0.121551 9.85745 0.364652L6 4.22075L2.14255 0.364652C1.65618 -0.121551 0.851153 -0.121551 0.36478 0.364652C-0.121593 0.850855 -0.121593 1.6556 0.36478 2.14181L4.22222 5.9979L0.36478 9.854C-0.121593 10.3402 -0.121593 11.145 0.36478 11.6312C0.616353 11.8826 0.93501 12 1.25366 12C1.57232 12 1.89098 11.8826 2.14255 11.6312L6 7.77506L9.85745 11.6312C10.109 11.8826 10.4277 12 10.7463 12C11.065 12 11.3836 11.8826 11.6352 11.6312C12.1216 11.145 12.1216 10.3402 11.6352 9.854L7.77778 5.9979Z"
            fill="#BD1D23"
          />
        </svg>
      </button>
    </div>
  );
}
